import { useEffect } from "react";

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, keywords, schema }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("description", description);
    setMeta("keywords", keywords);

    let script;
    if (schema) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }
    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, keywords, schema]);

  return null;
}
